import { Accordion, Typography, AccordionDetails } from '@mui/material';

import OverwatchAccordionSummary from './OverwatchAccordionSummary';

interface OverwatchAccordionProps {
  children: React.ReactNode;
  title?: string;
  height?: string;
  defaultExpanded?: boolean;
}
const OverwatchAccordion: React.FC<OverwatchAccordionProps> = ({
  children,
  title,
  height,
  defaultExpanded = false,
}) => {
  return (
    <Accordion sx={{ width: '100%', marginBottom: 1 }} defaultExpanded={defaultExpanded}>
      <OverwatchAccordionSummary>
        <Typography variant="body1">{title}</Typography>
      </OverwatchAccordionSummary>
      <AccordionDetails sx={{ height: height, maxHeight: height ?? 'calc(100vh - 400px)', overflow: 'auto' }}>
        {children}
      </AccordionDetails>
    </Accordion>
  );
};

export default OverwatchAccordion;
